import { CardActionArea } from "@mui/material";
import { useEmbeddedExitConfirm } from "../../hooks/useEmbeddedExitConfirm";
import EmbeddedExitConfirmDialog from "../modals/EmbeddedExitConfirmDialog";

export default function ExternalCardActionArea({
  href,
  target,
  children,
  onClick,
  ...rest
}) {
  const {
    dialogOpen,
    handleConfirm,
    handleCancel,
    createClickHandler,
    brandName,
    storagePrefix
  } = useEmbeddedExitConfirm();

  const handleClick = createClickHandler(href, target, onClick);

  return (
    <>
      <CardActionArea
        href={href}
        target={target}
        onClick={handleClick}
        {...rest}
      >
        {children}
      </CardActionArea>
      <EmbeddedExitConfirmDialog
        open={dialogOpen}
        onConfirm={handleConfirm}
        onCancel={handleCancel}
        brandName={brandName}
        storagePrefix={storagePrefix}
      />
    </>
  );
}
